export default {
  direction: "ltr"
};
